/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Go_BackInputs */

const en_onboarding_go_back = /** @type {(inputs: Onboarding_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back`)
};

const es_onboarding_go_back = /** @type {(inputs: Onboarding_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver`)
};

/**
* | output |
* | --- |
* | "Go back" |
*
* @param {Onboarding_Go_BackInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_go_back = /** @type {((inputs?: Onboarding_Go_BackInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Go_BackInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_go_back(inputs)
	return en_onboarding_go_back(inputs)
});